module.exports = __webpack_public_path__ + "static/media/ca-edit-read-icon.58e7c428.svg";